import React from "react";
import AdminPickupView from "../../views/adminView/adminPickupsView";

export default function AdminPickupViewPage() {
    return <AdminPickupView />
}